import { getBlockchainFromAddress } from "@anaconda/core/blockchain/address"
import type { CollectionId } from "@anaconda/core/nft-collection/types"
import { usePathname } from "next/navigation"
import { CollectionPageType } from "./collection-page-type"
import { getCollectionPathSegment } from "./collection-path"

export const getCollectionHref = (collectionId: CollectionId) => {
  const segment = getCollectionPathSegment(collectionId)
  const blockchain = getBlockchainFromAddress(collectionId)

  return `/${blockchain.toLowerCase()}/collections/${segment}`
}

const HREF_FACTORY_BY_PAGE_TYPE: Record<
  CollectionPageType,
  (colletionId: CollectionId) => string
> = {
  [CollectionPageType.ITEMS]: getCollectionHref,
  [CollectionPageType.MY_ITEMS]: (collectionId) =>
    `${getCollectionHref(collectionId)}/my-items`,
  [CollectionPageType.ACTIVITY]: (collectionId) =>
    `${getCollectionHref(collectionId)}/activity`,
  [CollectionPageType.OFFERS]: (collectionId) =>
    `${getCollectionHref(collectionId)}/offers`,
}

export const useCollectionPageHref = (
  collectionId: CollectionId,
  pageType: CollectionPageType,
) => HREF_FACTORY_BY_PAGE_TYPE[pageType](collectionId)

export const useCollectionActiveLinkChecker = (
  collectionId: CollectionId,
  pageType: CollectionPageType,
) => {
  const pathname = usePathname()
  const expectedHref = useCollectionPageHref(collectionId, pageType)

  return pathname === expectedHref
}

export const useCurrentCollectionPageType = (
  pathname: string | null = null,
) => {
  const currentPathname = usePathname()
  const targetPathname = pathname ?? currentPathname

  if (targetPathname.includes("/my-items")) {
    return CollectionPageType.MY_ITEMS
  }
  if (targetPathname.includes("/activity")) {
    return CollectionPageType.ACTIVITY
  }
  if (targetPathname.includes("/offers")) {
    return CollectionPageType.OFFERS
  }

  return CollectionPageType.ITEMS
}
